import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { ChitinCheckboxComponent } from '@shared/components/chitin/atoms/checkbox/checkbox.component';

@Component({
  selector: 'app-formly-field-checkbox',
  template: `
    <chitin-checkbox
      [mode]="field.props?.mode ?? 'checkbox'"
      [name]="field.props?.name"
      [size]="field.props?.size ?? 'medium'"
      [disabled]="field.props?.disabled ?? false"
      [reverse]="field.props?.reverse ?? false"
      [label]="field.props?.label"
      [value]="formControl.value"
      (valueChange)="onValueChange($event)"
    />
  `,
  imports: [ChitinCheckboxComponent],
})
export class FormlyFieldCheckboxComponent extends FieldType<FieldTypeConfig> {
  onValueChange(value: boolean) {
    this.formControl.setValue(value);
    this.formControl.markAsDirty();
  }
}
